import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Form, Input, type FormInstance } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

import { Title } from '@/components/Typography';
import { Utils } from '@/utils/index';

interface ChangePasswordFormProps {
	form: FormInstance;
}

export function ChangePasswordForm({ form }: Readonly<ChangePasswordFormProps>) {
	function handleBlockingEvent(e: React.FormEvent<HTMLInputElement>) {
		e.preventDefault();
		return false;
	}

	return (
		<Form form={form} layout="vertical">
			<Title level={4} style={{ paddingBottom: '1rem' }}>
				Change password
			</Title>
			<Form.Item
				label={I18n.get('Current password')}
				name="current_password"
				hasFeedback
				rules={[
					{
						required: true,
						message: I18n.get('Enter your current password')
					}
				]}
			>
				<Input.Password
					placeholder={I18n.get('Enter your current password')}
					iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
				/>
			</Form.Item>
			<Form.Item
				label={I18n.get('New password')}
				name="password"
				hasFeedback
				rules={[
					() => ({
						validator(_, value) {
							return Utils.checkingPassword(value);
						}
					})
				]}
			>
				<Input.Password
					placeholder={I18n.get('Enter your new password')}
					iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
				/>
			</Form.Item>
			<Form.Item
				label={I18n.get('Confirm password')}
				name="password_confirm"
				dependencies={['password']}
				hasFeedback
				rules={[
					{
						required: true,
						message: I18n.get('Repeat your new password')
					},
					({ getFieldValue }) => ({
						validator(_, value) {
							if (!value || getFieldValue('password') === value) {
								return Promise.resolve();
							}

							return Promise.reject(I18n.get("The two passwords don't match, check"));
						}
					})
				]}
			>
				<Input.Password
					placeholder={I18n.get('Confirm new password')}
					iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
					autoComplete="off"
					onCopy={handleBlockingEvent}
					onDrag={handleBlockingEvent}
					onDrop={handleBlockingEvent}
					onPaste={handleBlockingEvent}
				/>
			</Form.Item>
		</Form>
	);
}
